var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({staticClass:"radio-color h-4 w-4 rounded-full bg-AkWhite border appearance-none md:h-6 md:w-6 md:checked:border-2",class:_vm.isChecked
      ? 'border-theme-secondary'
      : 'border-AkGreyscaleMediumLtGrey',attrs:{"type":"radio"},domProps:{"checked":_vm.isChecked,"value":_vm.value}},'input',_vm.$attrs,false),_vm.inputListeners))}
var staticRenderFns = []

export { render, staticRenderFns }